import React from 'react';

import { Grid, IconButton } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { ExpandLess } from '@material-ui/icons';
import { LumaTheme } from 'embeds/core/styles/getTheme';
import { includes } from 'lodash';

import { Chip } from 'components/v2';

import { useFiltersContext, useTabContext } from '../context/FixedFiltersContext';

import { BILLING_STATUS } from './constants';

const styles = ({ spacing: { unit } }: LumaTheme) =>
  createStyles({
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: `12px 0px ${unit * 2}px ${unit * 3}px`,
      minHeight: 50,
      maxHeight: 150,
      overflow: 'auto',
    },
  });

const FILTER_KEY = 'billingStatus';
const FILTER_ALL_OPTION = 'all';

interface FiltersBillingStatusProps extends WithStyles<typeof styles> {}

const FiltersBillingStatus: React.FC<FiltersBillingStatusProps> = ({ classes }) => {
  const { updater, filters } = useFiltersContext();
  const { changeTab } = useTabContext();
  const billingStatusFilter = filters[FILTER_KEY];
  const isSelected = (id: string) =>
    (includes(billingStatusFilter, FILTER_ALL_OPTION) && !includes(billingStatusFilter, id)) ||
    (includes(billingStatusFilter, FILTER_ALL_OPTION) && billingStatusFilter.length === 1) ||
    (!includes(billingStatusFilter, FILTER_ALL_OPTION) && includes(billingStatusFilter, id));

  return (
    <div className={classes.contentWrapper}>
      <Grid container spacing={8}>
        {BILLING_STATUS.map((item: any) => (
          <Grid item key={item.value}>
            <Chip
              color="supportPowder"
              label={item.label}
              onClick={() => updater(FILTER_KEY)(item.value)}
              selected={isSelected(item.value)}
            />
          </Grid>
        ))}
      </Grid>
      <IconButton onClick={() => changeTab({ tab: null, index: false })}>
        <ExpandLess />
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(FiltersBillingStatus);
